// extracted by css-extract-rspack-plugin
export default {"main":"ksMPB","resizing":"zo8qz"};